import { useRef } from 'react';
import MissionsInfiniteList from './missionsInfiniteList';
import FilterListMissions from '../utils/filterLists/filterListMissions';
import ListPageLayout from '../utils/ListPageLayout';

function MissionsPage() {
  const updateQueryFunc = useRef(null);

  function handleQuery(filters) {
    if (typeof updateQueryFunc.current === 'function') { updateQueryFunc.current(filters); }
  }

  return (
    <>
      <ListPageLayout
        title="Missions"
        tagline="Eighth Air Force missions, organized by date."
        sidebar={<FilterListMissions isFiltered={handleQuery} />}
      >
        <MissionsInfiniteList filterQuery={updateQueryFunc} />
      </ListPageLayout>
    </>
  );
}

export default MissionsPage;
